var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('van-overlay',{attrs:{"show":_vm.show}}),_c('div',{staticClass:"loader"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }